import { allocationByEntityToDrawdownFund } from "features/drawdown/DrawdownUtils";
import {
  FeePostApplyOffsetsAllocationDetailsDrawer,
  FeePostApplyOffsetsAllocationDetailsDrawerProps,
} from "features/fees/post/apply-offsets/FeePostApplyOffsetsAllocationDetailsDrawer";
import { GenericTableData } from "gen/model/genericTableData";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableBox } from "shared/components/table/box/TableBox";
import { TableBoxBody } from "shared/components/table/box/TableBoxBody";
import { TableBoxHeader } from "shared/components/table/box/TableBoxHeader";
import { TableBoxTitle } from "shared/components/table/box/TableBoxTitle";
import { DataTable } from "shared/components/table/data/DataTable";
import { DataTableBoxActions } from "shared/components/table/data/DataTableBoxActions";
import {
  DataTableOnButtonClickFn,
  GetLinkInfoForCellFn,
} from "shared/components/table/data/DataTableTypes";

export const OffsetApplicationsTableWithAllocationsDrawer: React.FC<{
  feeOffsetApplicationsTableData: GenericTableData;
}> = ({ feeOffsetApplicationsTableData }) => {
  const { t } = useTranslation(["fees"]);

  const [allocationDetails, setAllocationDetails] = useState<
    FeePostApplyOffsetsAllocationDetailsDrawerProps | undefined
  >(undefined);

  const onButtonClick = useCallback<DataTableOnButtonClickFn>(
    ({ cell }) => {
      const metadata = cell?.metadata;
      if (!metadata || metadata.type !== "fee_offset_application") {
        return;
      }
      const drawdownFunds =
        metadata.pro_rata_allocation_data.allocation_by_entity.map(
          allocationByEntityToDrawdownFund,
        );
      setAllocationDetails({
        onCloseComplete: () => setAllocationDetails(undefined),
        allocations: drawdownFunds,
        feeCode: metadata.transaction_code_name,
      });
    },
    [setAllocationDetails],
  );

  const getLinkInfoForCell = useCallback<GetLinkInfoForCellFn>(
    (props) =>
      props.type === "data" &&
      props.cell.metadata?.type === "fee_offset_application"
        ? {
            type: "generic",
            to: "",
          }
        : undefined,
    [],
  );

  return (
    <TableBox>
      <TableBoxHeader>
        <TableBoxTitle>{t("fees:offsets.title")}</TableBoxTitle>
        <DataTableBoxActions />
      </TableBoxHeader>
      <TableBoxBody>
        <DataTable
          data={feeOffsetApplicationsTableData}
          onButtonClick={onButtonClick}
          getLinkInfoForCell={getLinkInfoForCell}
        />
        {allocationDetails && (
          <FeePostApplyOffsetsAllocationDetailsDrawer {...allocationDetails} />
        )}
      </TableBoxBody>
    </TableBox>
  );
};
